// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"07fe1154","484":"295c50ac"}[chunkId] + ".chunk.js";
};